import { Input, EventEmitter, Component, Output } from '@angular/core';

@Component({
	selector: 'paginator',
	templateUrl: './paginator.component.html',
	styleUrls: [ ]
})
export class PaginatorComponent<T> {

	public rows: T[] = [];
	public page = 0;
	private total = 0;
	public lastPage = 0;
	private size = 10;

	@Input()
	get pageSize() {
		return this.size;
	}

	set pageSize(value: number) {
		this.size = value;
		this.reset();
	}
	
	@Input()
	get items() {
		return this.rows;
	}

	set items(value: T[]) {
		this.rows = value || [];
		this.reset();
	}

	@Output()
	currentPage = new EventEmitter<T[]>();

	private reset() {
		this.total = Math.ceil(this.items.length / this.pageSize);
		this.lastPage = Math.max(0, this.total - 1);
		this.page = 0;

		// PORK: per evitare problemi di binding...
		//
		//		<`--'\>______
		//		/. .  `'     \
		//	   (`')  ,        @
		//		`-._,        /
		//		   )-)_/--( >
		//
		setTimeout(() => this.currentPage.next(this.getCurrentPage()));
	}

	private getCurrentPage() {
		return this.items.slice(this.page * this.pageSize, this.page * this.pageSize + this.pageSize);
	}

	private goto(page: number) {
		this.page = page;
		this.currentPage.next(this.getCurrentPage());
	}

	public next() {
		this.goto(Math.max(0, Math.min(this.total - 1, this.page + 1)));
	}

	public prev() {
		this.goto(Math.max(0, this.page - 1));
	}

	public get indexes(): number[] {
		let start = Math.max(0, this.page -1);
		return Array.range(start, Math.min(this.total - start, 3));
	}

	public get lastItem() {
		return Math.min(this.items.length, this.page * this.pageSize + this.pageSize);
	}
}


// WEBPACK FOOTER //
// ./src/app/components/paginator/paginator.component.ts